var styles = {
  "SimpleBarSkeleton": "_SimpleBarSkeleton_1nscx_1",
  "Item": "_Item_1nscx_8"
};

export { styles as default };
